import axios from 'axios';
import {
    STUDENTREPORT_GET_ONE,
    STUDENTREPORT_GET_MULTIPLE,
    STUDENTREPORT_REGISTER_SUCCESS,
    STUDENTREPORT_REGISTER_FAIL,
    STUDENTREPORT_LOADING,
    STUDENTREPORT_LOADING_ERROR,
    STUDENTREPORT_UPDATE_SUCCESS,
    STUDENTREPORT_UPDATE_FAIL,
    STUDENTREPORT_DELETE_SUCCESS,
    STUDENTREPORT_DELETE_FAIL
} from "../types/studentreport";
import { MAIN_TOKEN, SERVER_PATH, axiosConfig1, axiosConfig } from './common';

let TABLE_NAME = 'studentreports';
const path = SERVER_PATH;

//GET ALL STUDENTREPORT 
export const getStudentreports = params => (dispatch, getState) => {
    //SET PAGE LOADING
    params.token = MAIN_TOKEN;
    params.table = TABLE_NAME;

    dispatch({type : STUDENTREPORT_LOADING});
        axios.get(path, {params}, axiosConfig)
            .then(res => {                                                                                                                                                                                                                                        
                dispatch({
                    type: STUDENTREPORT_GET_MULTIPLE,
                    payload: res.data
                })
            })
            .catch(err => {
                dispatch({
                    type : STUDENTREPORT_LOADING_ERROR,
                    payload:err
                })
            })
};
//GET SINGLE STUDENTREPORT 
export const getStudentreport = id => (dispatch, getState) => {
    //SET PAGE LOADING
    dispatch(
        {
        type : STUDENTREPORT_GET_ONE,
        payload: id
    });  
};
//STUDENTREPORT DELETE
export const deleteStudentreport = params => (dispatch, getState) =>{
    axios.POST(path, {params}, axiosConfig)
        .then(res => {
            dispatch({
                type: STUDENTREPORT_DELETE_SUCCESS,
                payload: params.id
            })
        })
        .catch(err => {
            dispatch({
                type : STUDENTREPORT_DELETE_FAIL,
                payload : err
            })
        })
        
}
//STUDENTREPORT REGISTER
export const registerStudentreport = data => dispatch => {
    axios.post(path, data, axiosConfig1)
        .then(res => {
            dispatch({
                type: STUDENTREPORT_REGISTER_SUCCESS,
                payload: res.data.data
            })
        })
        .catch(err => {
            dispatch({
                type : STUDENTREPORT_REGISTER_FAIL,
                payload: err
            })
        })
};
 //STUDENTREPORT UPDATE
export const updateStudentreport = (data) => (dispatch, getState) => {
    //body
    axios.post(path, data, axiosConfig1)
        .then(res => {
            dispatch({
                type: STUDENTREPORT_UPDATE_SUCCESS,
                payload: res.data.data
            })
        })
        .catch(err => {
            dispatch({
                type : STUDENTREPORT_UPDATE_FAIL,
                payload: err
            })
        })
};
